'use client';

import Link from 'next/link';

import CheckIcon from '@/components/icons/check';

export const SaleApplicationSuccess = () => {
  return (
    <div className="space-y-4">
      <div className="mx-auto bg-white rounded-xl p-6 md:py-8 md:px-6 flex flex-col items-center justify-center text-center space-y-6 max-w-[463px]">
        <div className="inline-flex h-14 w-14 items-center justify-center rounded-xl bg-[#F1F2FF] ">
          <CheckIcon className="h-6 w-6 text-[#505CFF] " />
        </div>

        <div className="space-y-3">
          <h3 className="text-xl font-bold text-[#1B1D22] leading-[1.25]">
            Bаше заявление на подключение успешно принято
          </h3>
          <p className="text-base text-[#6C7286]">
            Менеджер свяжется с вами в течение 1–2 рабочих дней для уточнения деталей.
          </p>
        </div>
      </div>

      <div className="flex flex-col items-center justify-center text-center">
        <p className="text-sm font-normal text-[#6C7286]">Появились вопросы?</p>
        <p className="text-sm font-normal text-[#6C7286]">
          Напишите на{' '}
          <Link
            href="mailto:support@molwe.ru"
            className="underline text-[#505CFF] hover:opacity-80"
          >
            support@molwe.ru
          </Link>
        </p>
      </div>
    </div>
  );
};
